import { forwardRef } from 'react';

import { useAddBusinessPlan } from '@editor/global/growthbookUtils';

import { PlanDetails } from './PlanDetails';
import { PlanContainer, PlanContent } from './styles';
import { PricingPlanProps } from './types';

/**
 * display data for a pricing plan
 */
const NewPricingPlan = forwardRef<HTMLDivElement, PricingPlanProps>(
  (props, ref) => {
    const businessPlanIsEnabled = useAddBusinessPlan();

    return (
      <PlanContainer
        ref={ref}
        businessPlanIsEnabled={businessPlanIsEnabled}
        className={props.className}
        hasLabel={!!props.isHighlighted}
        height={props.height}
        isTeamsContainer={!!props.memberSelect}
        state={props.state}
      >
        <PlanContent
          center={props.centerContent}
          hasLabel={!!props.isHighlighted}
        >
          <PlanDetails {...props} />
        </PlanContent>
      </PlanContainer>
    );
  }
);

NewPricingPlan.displayName = 'PricingPlan';

export default NewPricingPlan;
